import type { CsvAnalysis } from 'troppus-common/shared';

import type { ColumnDraft, FormValues } from './types';

/** CSV 解析完了時にフォームへ反映するフィールド一式（既存の sourceSystemId 等は親でマージする） */
export type ConfigureFormPatchFromAnalysis = Pick<
  FormValues,
  'displayName' | 'columns' | 'contractUkColumns' | 'customerUkEnabled' | 'customerUkColumns'
>;

export function buildConfigureFormPatchFromAnalysis(next: CsvAnalysis, csvFileName: string): ConfigureFormPatchFromAnalysis {
  const nextColumns: ColumnDraft[] = next.columns.map((col) => ({
    name: col.name,
    destination: col.inferredDestination,
    type: col.inferredType,
    required: false,
    multiValued: false,
    transformRules: [...col.inferredTransformRules],
    sampleValues: col.sampleValues,
  }));

  const draftContractUk = next.uniqueKeysDraft.contract.columnNames.filter((n) =>
    next.columns.some((c) => c.name === n && c.inferredDestination === 'contract'),
  );

  const cust = next.uniqueKeysDraft.customer;
  const customerEnabled = !!cust?.columnNames?.length;
  const customerCols = customerEnabled
    ? (cust?.columnNames ?? []).filter((n) => next.columns.some((c) => c.name === n && c.inferredDestination === 'customer'))
    : [];

  return {
    displayName: csvFileName,
    columns: nextColumns,
    contractUkColumns: draftContractUk,
    customerUkEnabled: customerEnabled,
    customerUkColumns: customerCols,
  };
}
